import { render, staticRenderFns } from "./ticket_add.vue?vue&type=template&id=1a91dc1c&scoped=true&"
import script from "./ticket_add.vue?vue&type=script&lang=js&"
export * from "./ticket_add.vue?vue&type=script&lang=js&"
import style0 from "./ticket_add.vue?vue&type=style&index=0&id=1a91dc1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a91dc1c",
  null
  
)

export default component.exports